import React from 'react';

import { BasketIcon } from 'apps/urban/public/assets/images/Basket';
import { BasketIcon2 } from 'apps/urban/public/assets/images/Basket2';
import Link from 'next/link';

import { HeaderBasketWrapper } from './HeaderBasket.style';
import { HeaderBasketButtonWrapper } from '../../../components-v2/HeaderV2/HeaderV2Basket/HeaderV2Basket.style';

const DEFAULT_BASKET_BUTTON_TEXT = 'Book now';

export const HeaderBasket = ({
  basketData,
  basketButtonText,
  showOnMobile = false,
  fullWidth = false,
  useServiceOsAuth,
}) => {
  const { serviceCount, hasStartsAt, hasWorker } = basketData || {};

  const displayOneItem = serviceCount === 0 && (hasStartsAt || hasWorker);
  const hasAnyItem = serviceCount > 0 || displayOneItem;

  const numberOfItems = (n: number) => <span className="count">{n}</span>;
  if (useServiceOsAuth) {
    return (
      <HeaderBasketButtonWrapper showOnMobile={showOnMobile} fullWidth={fullWidth}>
        <button
          data-book-btn="true"
          style={{ fontFamily: 'Roboto, sans-serif' }}
          className="service-os-book-now"
        >
          {basketButtonText || DEFAULT_BASKET_BUTTON_TEXT}
        </button>
      </HeaderBasketButtonWrapper>
    );
  }

  return (
    <HeaderBasketWrapper hasItems={hasAnyItem}>
      <Link href="/booking-next/basket">
        <a className="link">
          {serviceCount > 0 && numberOfItems(serviceCount)}
          {displayOneItem && numberOfItems(1)}
          {hasAnyItem ? <BasketIcon2 theme="primary" /> : <BasketIcon theme />}
        </a>
      </Link>
    </HeaderBasketWrapper>
  );
};
